import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002a3bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Video Effect Setting", -1))
const _hoisted_3 = { class: "footer-setting" }

import { computed } from 'vue'
import BackgroundSetting from '@/components/checkup/BackgroundSetting.vue'
import { useBackgroundStore, useDeviceStore, useRoomStore } from '@/stores'
import { covertVideoBgToBackgroundType } from '../../helpers/background.helper'
import useSpaceApi from '../../composables/api/useSpaceApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'apply-background'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { saveLogsChangeBackground } = useSpaceApi()

/**
 * Store
 */
const device = useDeviceStore()
const background = useBackgroundStore()
const roomStore = useRoomStore()

/**
 * State
 */

const isChanged = computed(() => background.backgroundChanged || device.cameraOnChanged)
const engine = computed(() => roomStore.currentEngine)

/**
 * Methods
 */
const toggle = () => {
  device.cameraOn = device.maskCameraOn
  device.setStateEnableToLocal()
  emit('update:modelValue', !props.modelValue)
}

const cancel = () => {
  background.selectedBackground = background.currentBackground
  toggle()
  emit('update:modelValue', false)
}

const submit = () => {
  background.setStateBackground(background.selectedBackground)
  // Log Change Background
  const { backgroundType, imagePath } = covertVideoBgToBackgroundType(background.currentBackground)
  saveLogsChangeBackground({ engine: engine.value, backgroundType, imagePath })
  toggle()
  emit('apply-background')
}

return (_ctx: any,_cache: any) => {
  const _component_BetaTag = _resolveComponent("BetaTag")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: "Video Effect Setting",
    open: __props.modelValue,
    onClose: toggle
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_BetaTag, { class: "ml-1" })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (isChanged.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tertiary",
                onClick: cancel
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: submit
              }, "Apply")
            ], 64))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-tertiary",
              onClick: cancel
            }, _toDisplayString(_ctx.$t('close-button')), 1))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (__props.modelValue)
          ? (_openBlock(), _createBlock(BackgroundSetting, {
              key: 0,
              engine: engine.value
            }, null, 8, ["engine"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})